import type { Shipment } from '../../models/shipments';
import { RootState } from '../store';

/**
 * A combined array of fetched shipment(s) and recently searched shipment
 * @returns existing shipments and additional searched shipment (that is not a duplicate)
 */
export const selectShipments = (state: RootState): Shipment[] | [] => {
  const shipmentList = state.shipmentList.data || [];
  const removedIds = state.shipmentList.removedArticleIds ?? [];
  const recentlySearched = state.shipmentList.recentlySearched || [];

  if (!shipmentList?.length && !recentlySearched?.length) return [];

  const searchedIds = new Set(shipmentList.map((searchedShipment) => searchedShipment.consignmentId));

  const combinedSearchResults = [
    ...shipmentList,
    ...recentlySearched.filter((newSearched) => !searchedIds.has(newSearched.consignmentId)),
  ];

  if (removedIds.length) {
    const removedIdSet = new Set(removedIds);
    const updatedResult = [...combinedSearchResults].filter((combined) => !removedIdSet.has(combined.consignmentId));
    return updatedResult;
  }
  return combinedSearchResults;
};
export const selectShipment = (state: RootState) => {
  return state.shipmentDetails.data;
};

export const isListShipmentLoading = (state: RootState): boolean => {
  return state.shipmentList?.getShipmentList?.loading || false;
};
